import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import InvestmentPriceGraph from '../moneyBuilder/investments/investment_price_graph';

class GenericModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        
    }    
    this.displayGraph = false;
    this.splitInputObj();
}

splitInputObj(){
    if (this.props.modalName === "displayGraph"){
        this.investmentName = this.props.dataObj.investmentName;
        this.monthNbr = this.props.dataObj.monthNbr;
        this.firstMonthDate = this.props.dataObj.firstMonthDate;
        this.investType = this.props.dataObj.investType;
        this.buyDates = this.props.dataObj.buyDates;
        this.investShortName = this.props.dataObj.shortName;
        this.displayGraph = true;
    }
}

render() {
                               
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="xl" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>{this.props.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {this.displayGraph   ?
                <span>
                    <div>
                        <b>Graph is For: </b>{this.investmentName}&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>InvestType: </b> {this.investType}&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>End Month Number:</b>  {this.monthNbr}
                    </div>
                <InvestmentPriceGraph
                        investmentName = {this.investmentName}
                        monthNbr={this.monthNbr}
                        fromProcess={"admin"}
                        firstMonthDate={this.firstMonthDate}
                        investType={this.investType}
                        buyDates={this.buyDates}
                        investShortName={this.investShortName}
                        processError = {(errorObj) => this.props.processError(errorObj)}
                    />
                </span>
            :
                null
            }
           
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>
    
  </>
  }

}

export default GenericModal;